/**
 * @name 图标
 */
import Menu from './menu';
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Menu.install = function(Vue) {
  Vue.component(Menu.name, Menu);
  Vue.use(PerfectScrollbar)
};

export default Menu;
